import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import TagsView from "../views/TagsView.vue";
import AnalyticsView from "@/views/AnalyticsView.vue";
import FeedUrlView from "@/views/FeedUrlView.vue";

const routes = [
  {
    path: "/:pathMatch(.*)*",
    redirect: "/main",
  },
  {
    path: "/login",
    name: "login",
  },
  {
    path: "/lk",
    name: "lk",
  },
  {
    path: "/main",
    children: [
      {
        path: "",
        name: "home",
        component: HomeView,
      },
      {
        path: "feed-url",
        name: "feed-url",
        component: FeedUrlView
      }
    ]
  },
  {
    path: "/tag",
    name: "tag",
    component: TagsView,
  },
  {
    path: "/analytics",
    name: "analytics",
    component: AnalyticsView,
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (window.hasUnsavedChanges) {
    window.dispatchEvent(new Event("showUnsavedChangesModal")); // Инициируем показ модального окна

    // Ждем подтверждения выхода
    const handleConfirmLeave = () => {
      router.push(to);
      window.removeEventListener("confirmLeave", handleConfirmLeave);
    };

    window.addEventListener("confirmLeave", handleConfirmLeave);
    next(false); // Останавливаем переход
    return;
  } else {
    next();
  }
});

export default router;
